// Saúde de uma conexão de WhatsApp a partir do config do conector (STU-176).
// O backend grava: status "active"/"inactive", link "down" (caiu e não voltou
// em ~5 min) e disconnectReason ("logged_out" = o celular saiu; "banned" = o
// WhatsApp/Meta bloqueou o número; "manual" = o próprio usuário desconectou,
// sem aviso).
// Retorna null para conector que não é WhatsApp (o card segue "configurado").
export const connectorHealth = c => {
  if (!c || (c.type !== "whatsapp_qr" && c.type !== "gupshup")) return null;
  const cfg = c.config || {};
  if (c.type === "gupshup") {
    return cfg.status === "active"
      ? { state: "ok", label: "conectado" }
      : { state: "pending", label: "aguardando ativação" };
  }
  if (cfg.status === "active" && cfg.link === "down") return { state: "down", label: "sem conexão", alert: true };
  if (cfg.status === "active") return { state: "ok", label: "conectado" };
  if (cfg.disconnectReason === "logged_out") return { state: "logged_out", label: "desconectado", alert: true };
  if (cfg.disconnectReason === "banned") return { state: "logged_out", label: "bloqueado pelo WhatsApp", alert: true };
  if (cfg.disconnectReason === "manual") return { state: "off", label: "desconectado" };
  return { state: "pending", label: "não conectado" };
};

export const HEALTH_COLOR = { ok: "#2f9e44", down: "#E8A33D", logged_out: "#D14343", off: "#929AA4", pending: "#929AA4" };
